<script lang="ts">
    import type {DayOptimisationJobTypeSummary} from '../types';
    import ErpCard from 'src/features/erp/components/erp-card/ErpCard.svelte';
    import KpBarebonesTable from 'shared/ui-widgets/table/barebones/KpBarebonesTable.svelte';
    import ColoredLabel from '../../../../../../components/ColoredLabel.svelte';

    export let jobTypeSummary: DayOptimisationJobTypeSummary;
</script>

<ErpCard>
    <svelte:fragment slot="header">
        <ColoredLabel label="{jobTypeSummary.name}"/>
    </svelte:fragment>

    <svelte:fragment slot="body">
        <KpBarebonesTable headerFooterDivided fontSize="12px">
            <tr slot="header">
                <th>Typ</th>
                <th>Vykázaná data</th>
                <th>Účtovaná data</th>
                <th>Rozdíl</th>
            </tr>

            <svelte:fragment slot="body">
                <tr>
                    <td>Počet pracovníků</td>
                    <td>10</td>
                    <td>12</td>
                    <td class="difference-value">+2</td>
                </tr>

                <tr>
                    <td>Součet hodin</td>
                    <td>203 hodin</td>
                    <td>300 hodin</td>
                    <td class="difference-value">+97 hodin</td>
                </tr>

                <tr>
                    <td>Sazba</td>
                    <td>400 Kč</td>
                    <td>550 Kč</td>
                    <td class="difference-value">+150 Kč</td>
                </tr>
            </svelte:fragment>

            <tr slot="footer">
                <td>Celková cena</td>
                <td class="price-value">80 600 Kč</td>
                <td class="price-value">110 000 Kč</td>
                <td class="difference-value price-value">+29 400 Kč</td>
            </tr>
        </KpBarebonesTable>
    </svelte:fragment>
</ErpCard>

<style lang="less">
    @import (reference) "styles/portaro.variables.less";

    .difference-value {
        color: var(--success-green);
    }

    .price-value {
        font-weight: 500;
        font-size: @font-size-default;
    }
</style>